import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { SignalRService } from './pages/login/shared/signalr.service';
import { VariablesService } from './globalService/variables.service';
import { InfoUserService } from './info-user/shared/info-user.service';
import { Router } from '@angular/router';
import { MessageSweetAService } from './shared/messages/message-sweet-a.service';
import { LoginService } from './pages/login/shared/login.service';
import { CryptoService } from './shared/crypto/crypto.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ClientApp';
  cookieMessage = "Our Websites use first party and third party cookies. These cookies help us to understand the people who visit our Websites by enabling us to collect browsing and usage statistics, reach users with more relevant ads, and personalize content. Opt-out of certain cookies and manage your cookie preferences for our Websites at any time via our Cookie Preferences tool. ";
  cookieDismiss = "Ok";
  cookieLinkText = "Privacy Policy";
  cookieUrlCookiePrivacity = "https://www.willistowerswatson.com/en-US/Notices/global-website-privacy-notice";


  @ViewChild(NavBarComponent) navBar: NavBarComponent;

  constructor(
    private translate: TranslateService,
    private jwtHelper: JwtHelperService,
    private variableService: VariablesService,
    private _signalRService: SignalRService,
    private _userInfo: InfoUserService,
    private router: Router,
    private messageSweetService: MessageSweetAService,
    private loginService: LoginService,
    private encryptService: CryptoService,
  ) {
    //debugger;
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    let cc = window as any;
    cc.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#f2f2f2"
        },
        button: {
          background: "#702082",
          text: "#ffffff"
        }
      },
      theme: "classic",
      content: {
        message: this.cookieMessage,
        dismiss: this.cookieDismiss,
        link: this.cookieLinkText,
        href: this.cookieUrlCookiePrivacity 
      }
    });
    this.variableService.getVariables().then((result) => {
      this.initSignalr();
    });
    
  }

  //Función implementada para setear el idioma al Translate Service
  setLanguage(lang) {
    this.translate.use(lang);
  }

  getJwt(from: any) {
    let token = sessionStorage.getItem('jwt');

    let flag = token != null;
    if (!flag) {
      sessionStorage.removeItem('userInfo');
    }
    return flag;
  }

  initSignalr(){
    this._signalRService.startConnection(this.variableService.data.urlApi);
    this._signalRService.addListener('userValidation', (response)=>{
      this.validateSesion(response);
    });
  }

  validateSesion(data: any){
    setTimeout(async () => {
      let stringJwt = sessionStorage.getItem('jwt');
      if (stringJwt != null){
        let tempTolen = "";
        let dataToSend  = {token:stringJwt};
          await this.loginService.dt(dataToSend).then((result:any) => {
            tempTolen = result.result;
        });
        let token = this.jwtHelper.decodeToken(tempTolen);
        let hashT = token.payLoad.t;
        let hashU = token.payLoad.u;
        if(hashU == data?.u) {
          if(hashT != data?.t){
            this._userInfo.remove();
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userInfo");
            sessionStorage.clear();
            this.router.navigate(["home-page"]);
            this.messageSweetService.messageWaring("Advertencia!", "Se ha cerrado la sesión porque se inició en otro equipo");
          }
        }
      }
    }, 400);
  }
}
